// iter 307.92 — single source of truth for "this user belongs to a moving company".
export const isMovingTenantUser = (user) => !!user && user.role !== 'super_admin'
  && (user.industry_type === 'moving' || user.company_category === 'moving_company');

export const MOVING_BACK_OFFICE_ROLES = ['admin', 'dispatcher', 'op', 'accounting', 'office', 'owner'];

// Moving back-office users keep the Imports/Exports dashboard only when the super admin enabled it.
export const movingHome = (user) => (isMovingTenantUser(user) && MOVING_BACK_OFFICE_ROLES.includes(user.role)
  && !(user.nav_extras || []).includes('dashboard') ? '/moving' : null);
